import React from 'react'

const ModalHeader = (props) => {
    const { children, cssClass, style } = props
    return (
        <div className={`modalHeader ${cssClass || ''}`} style={style}>
            {children}
        </div>
    )
}

export default ModalHeader
